import { render } from "./Welcome.vue?vue&type=template&id=6704fdba&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=6704fdba&scoped=true&lang=css"

import exportComponent from "D:\\projects\\RED MENACE\\redmenacegames.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6704fdba"]])

export default __exports__